module.exports = __webpack_public_path__ + "img/at_the_top_of_ruins_of_st_pauls.c5c1a4d2.jpg";